module.exports = __webpack_public_path__ + "img/letter_back.86d5db4b.png";